(function () {
  const form = document.getElementById('river-run-registration-form');
  const messageEl = document.getElementById('river-run-form-message');
  const waiverDate = document.getElementById('waiver-date');
  const waiverName = document.getElementById('waiver-name');
  const fullNameInput = form ? form.querySelector('[name="properties[Full Name]"]') : null;

  const shirtTankGroup = document.querySelector('[data-gear-group="shirt-tank"]');
  const hatFlagGroup = document.querySelector('[data-gear-group="hat-flag"]');

  const signatureCanvas = document.getElementById('waiver-signature-canvas');
  const signaturePadEl = document.getElementById('signature-pad');
  const signaturePlaceholder = document.getElementById('signature-placeholder');
  const signatureClearBtn = document.getElementById('signature-clear');

  if (waiverDate) {
    waiverDate.value = new Date().toISOString().split('T')[0];
  }

  if (fullNameInput && waiverName) {
    fullNameInput.addEventListener('blur', function () {
      if (!waiverName.value.trim() && fullNameInput.value.trim()) {
        waiverName.value = fullNameInput.value.trim();
      }
    });
  }

  function setMessage(text, type) {
    if (!messageEl) return;
    messageEl.textContent = text;
    messageEl.className = 'river-run__message' + (type ? ' is-' + type : '');
  }

  function createSignaturePad(canvas, padEl, placeholderEl) {
    if (!canvas) {
      return {
        isEmpty: function () {
          return true;
        },
        clear: function () {},
        toBlob: function (callback) {
          callback(null);
        }
      };
    }

    const ctx = canvas.getContext('2d');
    let drawing = false;
    let hasStroke = false;
    let lastPoint = null;

    function resizeCanvas() {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      const rect = canvas.getBoundingClientRect();
      const imageData = hasStroke ? canvas.toDataURL('image/png') : null;

      canvas.width = Math.floor(rect.width * ratio);
      canvas.height = Math.floor(rect.height * ratio);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.scale(ratio, ratio);
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = 2.5;
      ctx.strokeStyle = '#111';

      if (imageData) {
        const img = new Image();
        img.onload = function () {
          ctx.drawImage(img, 0, 0, rect.width, rect.height);
        };
        img.src = imageData;
      }
    }

    function getPoint(event) {
      const rect = canvas.getBoundingClientRect();
      const source = event.touches && event.touches.length ? event.touches[0] : event;
      return {
        x: source.clientX - rect.left,
        y: source.clientY - rect.top
      };
    }

    function markSigned() {
      hasStroke = true;
      if (padEl) padEl.classList.add('is-signed');
      if (placeholderEl) placeholderEl.style.display = 'none';
    }

    function startDrawing(event) {
      event.preventDefault();
      drawing = true;
      lastPoint = getPoint(event);
    }

    function draw(event) {
      if (!drawing || !lastPoint) return;
      event.preventDefault();

      const point = getPoint(event);
      ctx.beginPath();
      ctx.moveTo(lastPoint.x, lastPoint.y);
      ctx.lineTo(point.x, point.y);
      ctx.stroke();
      lastPoint = point;
      markSigned();
    }

    function stopDrawing(event) {
      if (event) event.preventDefault();
      drawing = false;
      lastPoint = null;
    }

    canvas.addEventListener('mousedown', startDrawing);
    canvas.addEventListener('mousemove', draw);
    canvas.addEventListener('mouseup', stopDrawing);
    canvas.addEventListener('mouseleave', stopDrawing);

    canvas.addEventListener('touchstart', startDrawing, { passive: false });
    canvas.addEventListener('touchmove', draw, { passive: false });
    canvas.addEventListener('touchend', stopDrawing, { passive: false });
    canvas.addEventListener('touchcancel', stopDrawing, { passive: false });

    window.addEventListener('resize', resizeCanvas);
    window.addEventListener('orientationchange', function () {
      setTimeout(resizeCanvas, 150);
    });

    resizeCanvas();

    return {
      isEmpty: function () {
        return !hasStroke;
      },
      clear: function () {
        const rect = canvas.getBoundingClientRect();
        ctx.clearRect(0, 0, rect.width, rect.height);
        hasStroke = false;
        if (padEl) padEl.classList.remove('is-signed');
        if (placeholderEl) placeholderEl.style.display = '';
      },
      toBlob: function (callback) {
        if (!hasStroke) {
          callback(null);
          return;
        }

        canvas.toBlob(function (blob) {
          callback(blob);
        }, 'image/png');
      }
    };
  }

  const signaturePad = createSignaturePad(
    signatureCanvas,
    signaturePadEl,
    signaturePlaceholder
  );

  if (signatureClearBtn) {
    signatureClearBtn.addEventListener('click', function () {
      signaturePad.clear();
    });
  }

  function formToProperties(formEl) {
    const properties = {};
    const formData = new FormData(formEl);

    formData.forEach(function (value, key) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) {
        properties[match[1]] = String(value).trim();
      }
    });

    return properties;
  }

  function getAddonItems() {
    return Array.from(document.querySelectorAll('[data-addon-item]'));
  }

  function getAddonKind(el) {
    const handle = (el.dataset.addonHandle || '').toLowerCase();
    const heading = (el.dataset.addonHeading || '').toLowerCase();

    if (
      (handle.includes('t-shirt') || handle.includes('tshirt') || heading.includes('t-shirt')) &&
      !handle.includes('tank') &&
      !heading.includes('tank')
    ) {
      return 'shirt';
    }
    if (handle.includes('tank') || heading.includes('tank')) {
      return 'tank';
    }
    if (handle.includes('hat') || heading.includes('hat')) {
      return 'hat';
    }
    if (handle.includes('flag') || heading.includes('flag')) {
      return 'flag';
    }
    if (handle.includes('bead') || heading.includes('bead')) {
      return 'beads';
    }
    return 'other';
  }

  function getGearPanelData(panel) {
    const script = panel.querySelector('[data-gear-variants-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getGearPanelSelects(panel) {
    return Array.from(panel.querySelectorAll('[data-gear-option-select]'));
  }

  function getSelectedVariantFromPanel(panel) {
    if (!panel) return null;

    const data = getGearPanelData(panel);
    if (!data) return null;

    const autoVariant = panel.querySelector('[data-gear-auto-variant]');
    if (autoVariant && autoVariant.value) {
      return data.variants.find(function (variant) {
        return variant.available && String(variant.id) === autoVariant.value;
      }) || null;
    }

    const singleSelect = panel.querySelector('[data-gear-single-variant-select]');
    if (singleSelect) {
      if (!singleSelect.value) return null;
      return data.variants.find(function (variant) {
        return variant.available && String(variant.id) === singleSelect.value;
      }) || null;
    }

    const selects = getGearPanelSelects(panel);
    if (!selects.length) return null;

    if (selects.some(function (select) { return !select.value; })) {
      return null;
    }

    return data.variants.find(function (variant) {
      if (!variant.available) return false;

      return selects.every(function (select) {
        const position = select.dataset.optionPosition;
        const key = 'option' + position;
        return variant[key] === select.value;
      });
    }) || null;
  }

  function getFirstEnabledSelectOption(select) {
    return (
      Array.from(select.options).find(function (option, index) {
        return index > 0 && !option.disabled && option.value;
      }) || null
    );
  }

  function selectDefaultGearOptions(panel) {
    if (!panel) return;

    const singleSelect = panel.querySelector('[data-gear-single-variant-select]');
    if (singleSelect) {
      const firstOption = getFirstEnabledSelectOption(singleSelect);
      if (firstOption) singleSelect.value = firstOption.value;
      return;
    }

    if (panel.querySelector('[data-gear-auto-variant]')) return;

    const selects = getGearPanelSelects(panel);
    if (!selects.length) return;

    const sortedSelects = selects.slice().sort(function (a, b) {
      return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
    });

    sortedSelects.forEach(function (select) {
      select.value = '';
    });

    refreshGearOptionSelects(panel);

    sortedSelects.forEach(function (select) {
      const firstOption = getFirstEnabledSelectOption(select);
      if (firstOption) select.value = firstOption.value;
      refreshGearOptionSelects(panel);
    });
  }

  function refreshGearOptionSelects(panel) {
    const data = getGearPanelData(panel);
    const selects = getGearPanelSelects(panel);
    if (!data || !selects.length) return;

    selects.forEach(function (select) {
      const position = select.dataset.optionPosition;
      const key = 'option' + position;
      const filters = {};

      selects.forEach(function (otherSelect) {
        if (otherSelect === select || !otherSelect.value) return;
        filters['option' + otherSelect.dataset.optionPosition] = otherSelect.value;
      });

      const allowedValues = new Set();
      data.variants.forEach(function (variant) {
        if (!variant.available) return;

        const matches = Object.keys(filters).every(function (filterKey) {
          return variant[filterKey] === filters[filterKey];
        });

        if (matches && variant[key]) {
          allowedValues.add(variant[key]);
        }
      });

      Array.from(select.options).forEach(function (option, index) {
        if (index === 0) return;
        option.disabled = !allowedValues.has(option.value);
      });

      if (select.value && !allowedValues.has(select.value)) {
        select.value = '';
      }
    });
  }

  function resetGearPanelSelects(panel) {
    getGearPanelSelects(panel).forEach(function (select) {
      select.value = '';
      Array.from(select.options).forEach(function (option, index) {
        if (index === 0) return;
        option.disabled = false;
      });
    });

    const singleSelect = panel.querySelector('[data-gear-single-variant-select]');
    if (singleSelect) singleSelect.value = '';
  }

  function getActiveGearPanel(groupEl) {
    const typeRadio = groupEl.querySelector('[data-gear-type-radio]:checked');
    if (!typeRadio) return null;

    return groupEl.querySelector(
      '[data-gear-variant-panel="' + typeRadio.value + '"]'
    );
  }

  function getGearGroupData(groupEl) {
    if (!groupEl) {
      return {
        variantId: '',
        productKind: ''
      };
    }

    const typeRadio = groupEl.querySelector('[data-gear-type-radio]:checked');
    if (!typeRadio) {
      return {
        variantId: '',
        productKind: ''
      };
    }

    const panel = getActiveGearPanel(groupEl);
    const variant = getSelectedVariantFromPanel(panel);

    if (!variant) {
      return {
        variantId: '',
        productKind: typeRadio.value
      };
    }

    return {
      variantId: String(variant.id),
      productKind: typeRadio.value
    };
  }

  function updateGearHiddenValue(groupEl) {
    const hidden = groupEl.querySelector('[data-gear-hidden-property]');
    if (!hidden) return;

    const panel = getActiveGearPanel(groupEl);
    const data = panel ? getGearPanelData(panel) : null;
    const variant = getSelectedVariantFromPanel(panel);

    if (!variant || !data) {
      hidden.value = '';
      return;
    }

    hidden.value = data.productTitle + ' — ' + variant.title;
  }

  function setGearVariantPanels(groupEl, selectedKind) {
    groupEl.querySelectorAll('[data-gear-variant-panel]').forEach(function (panel) {
      const panelKind = panel.getAttribute('data-gear-variant-panel');
      const isActive = selectedKind && panelKind === selectedKind;

      panel.classList.toggle('is-hidden', !isActive);
      panel.hidden = !isActive;

      if (!isActive) {
        resetGearPanelSelects(panel);
      } else {
        selectDefaultGearOptions(panel);
        updateGearHiddenValue(groupEl);
      }
      updateGearPhoto(panel);
    });
  }

  function updateGearPhoto(panel) {
    if (!panel) return;
    const img = panel.querySelector('[data-gear-photo]');
    if (!img) return;

    const variant = getSelectedVariantFromPanel(panel);
    if (variant && variant.image) {
      img.src = variant.image;
    } else if (img.dataset.defaultSrc) {
      img.src = img.dataset.defaultSrc;
    }
  }

  function onGearOptionChange(groupEl, panel) {
    refreshGearOptionSelects(panel);
    updateGearPhoto(panel);
    updateGearHiddenValue(groupEl);
    syncIncludedGearToAddons();
  }

  function onGearTypeChange(groupEl) {
    const selected = groupEl.querySelector('[data-gear-type-radio]:checked');
    setGearVariantPanels(groupEl, selected ? selected.value : '');
    updateGearHiddenValue(groupEl);
    syncIncludedGearToAddons();
  }

  function bindGearGroups() {
    document.querySelectorAll('[data-gear-group]').forEach(function (groupEl) {
      const radios = groupEl.querySelectorAll('[data-gear-type-radio]');

      if (radios.length === 1) {
        radios[0].checked = true;
      }

      setGearVariantPanels(
        groupEl,
        groupEl.querySelector('[data-gear-type-radio]:checked')
          ? groupEl.querySelector('[data-gear-type-radio]:checked').value
          : ''
      );
      updateGearHiddenValue(groupEl);

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          onGearTypeChange(groupEl);
        });
      });

      groupEl.querySelectorAll('[data-gear-variant-panel]').forEach(function (panel) {
        getGearPanelSelects(panel).forEach(function (select) {
          select.addEventListener('change', function () {
            onGearOptionChange(groupEl, panel);
          });
        });

        const singleSelect = panel.querySelector('[data-gear-single-variant-select]');
        if (singleSelect) {
          singleSelect.addEventListener('change', function () {
            onGearOptionChange(groupEl, panel);
          });
        }
      });
    });
  }

  function setAddonByVariantId(addonEl, variantId) {
    const variantSelect = addonEl.querySelector('[data-addon-variant]');
    if (!variantSelect || !variantId) return false;

    const matchingOption = variantSelect.querySelector(
      'option[value="' + variantId + '"]'
    );

    if (!matchingOption) return false;

    variantSelect.value = variantId;
    return true;
  }

  function resetAddonStates() {
    getAddonItems().forEach(function (addonEl) {
      addonEl.classList.remove(
        'river-run__addon--active',
        'river-run__addon--dimmed',
        'river-run__addon--hidden',
        'river-run__addon--linked'
      );

      const variantSelect = addonEl.querySelector('[data-addon-variant]');
      if (variantSelect) {
        variantSelect.value = '';
      }
    });
  }

  function activateLinkedAddon(addonEl, variantId) {
    addonEl.classList.add('river-run__addon--linked', 'river-run__addon--active');
    addonEl.classList.remove('river-run__addon--dimmed');
    setAddonByVariantId(addonEl, variantId);
  }

  function syncIncludedGearToAddons() {
    if (!form) return;

    resetAddonStates();

    const shirtTankData = getGearGroupData(shirtTankGroup);
    const hatFlagData = getGearGroupData(hatFlagGroup);

    getAddonItems().forEach(function (addonEl) {
      const kind = getAddonKind(addonEl);

      if (kind === shirtTankData.productKind && shirtTankData.variantId) {
        activateLinkedAddon(addonEl, shirtTankData.variantId);
        return;
      }

      if (kind === hatFlagData.productKind && hatFlagData.variantId) {
        activateLinkedAddon(addonEl, hatFlagData.variantId);
        return;
      }

      // Everything else stays visible but blurred until hovered or selected.
      addonEl.classList.add('river-run__addon--dimmed');
    });
  }

  function updateAddonFocusStates() {
    getAddonItems().forEach(function (addonEl) {
      if (addonEl.classList.contains('river-run__addon--hidden')) return;

      const kind = getAddonKind(addonEl);
      const variantSelect = addonEl.querySelector('[data-addon-variant]');
      const isSelected = variantSelect && variantSelect.value !== '';
      const isLinked = addonEl.classList.contains('river-run__addon--linked');

      if (isLinked) {
        addonEl.classList.add('river-run__addon--active');
        addonEl.classList.remove('river-run__addon--dimmed');
        return;
      }

      if (kind === 'beads') {
        addonEl.classList.toggle('river-run__addon--active', isSelected);
        addonEl.classList.toggle('river-run__addon--dimmed', !isSelected);
        return;
      }

      addonEl.classList.toggle('river-run__addon--active', isSelected);
      addonEl.classList.toggle('river-run__addon--dimmed', !isSelected);
    });
  }

  function bindAddonSelectEvents() {
    getAddonItems().forEach(function (addonEl) {
      const variantSelect = addonEl.querySelector('[data-addon-variant]');
      if (!variantSelect) return;

      variantSelect.addEventListener('change', function () {
        if (variantSelect.value) {
          addonEl.classList.remove('river-run__addon--dimmed');
          addonEl.classList.add('river-run__addon--active');
        } else if (addonEl.classList.contains('river-run__addon--linked')) {
          addonEl.classList.add('river-run__addon--active');
          addonEl.classList.remove('river-run__addon--dimmed');
        } else {
          addonEl.classList.remove('river-run__addon--active');
          syncIncludedGearToAddons();
        }
      });

      addonEl.addEventListener('mouseenter', function () {
        if (!addonEl.classList.contains('river-run__addon--hidden')) {
          addonEl.classList.remove('river-run__addon--dimmed');
        }
      });

      addonEl.addEventListener('mouseleave', function () {
        updateAddonFocusStates();
      });
    });
  }

  function getSelectedIncludedGear() {
    const items = [];
    const shirtTankData = getGearGroupData(shirtTankGroup);
    const hatFlagData = getGearGroupData(hatFlagGroup);

    if (shirtTankData.variantId) {
      items.push({ id: Number(shirtTankData.variantId), quantity: 1 });
    }
    if (hatFlagData.variantId) {
      items.push({ id: Number(hatFlagData.variantId), quantity: 1 });
    }

    return items;
  }

  function getSelectedAddons() {
    const addons = [];
    const gearKinds = { shirt: true, tank: true, hat: true, flag: true };

    getAddonItems().forEach(function (addonEl) {
      if (addonEl.classList.contains('river-run__addon--hidden')) return;

      const kind = getAddonKind(addonEl);
      if (gearKinds[kind]) return;

      const variantSelect = addonEl.querySelector('[data-addon-variant]');
      if (!variantSelect || !variantSelect.value) return;

      addons.push({
        id: Number(variantSelect.value),
        quantity: 1
      });
    });

    return addons;
  }

  function collectCartLineItems() {
    const seen = new Set();
    const items = [];

    function pushItem(entry) {
      const id = Number(entry.id);
      if (!id || seen.has(id)) return;
      seen.add(id);
      items.push({ id: id, quantity: entry.quantity || 1 });
    }

    // Included shirt/tank and hat/flag are stored on the $40 registration
    // line item (properties only) — do not add them as separate cart items.
    getSelectedAddons().forEach(pushItem);
    getSelectedExtraProducts().forEach(pushItem);

    return items;
  }

  // ---- Optional Extras: "Add more product" (products tagged extra-option-products) ----
  const extraProductsRoot = document.querySelector('[data-extra-products]');
  const extraRowsEl = extraProductsRoot
    ? extraProductsRoot.querySelector('[data-extra-rows]')
    : null;
  const addExtraBtn = extraProductsRoot
    ? extraProductsRoot.querySelector('[data-add-extra-product]')
    : null;

  function getExtraProductsData() {
    const script = document.querySelector('[data-extra-products-data]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent) || [];
    } catch (error) {
      return [];
    }
  }

  const extraProductsData = getExtraProductsData();

  function findExtraProduct(handle) {
    return (
      extraProductsData.find(function (product) {
        return product.handle === handle;
      }) || null
    );
  }

  function getAvailableExtraVariants(product) {
    if (!product || !product.variants) return [];
    return product.variants.filter(function (variant) {
      return variant.available;
    });
  }

  function productRequiresOptionUi(product) {
    return getAvailableExtraVariants(product).length > 1;
  }

  function resolveExtraVariant(product, rowEl) {
    if (!product) return null;

    const autoVariant = rowEl.querySelector('[data-extra-auto-variant]');
    if (autoVariant && autoVariant.value) {
      return (
        product.variants.find(function (variant) {
          return variant.available && String(variant.id) === autoVariant.value;
        }) || null
      );
    }

    const selects = Array.from(rowEl.querySelectorAll('[data-extra-option-select]'));
    if (!selects.length) return null;
    if (selects.some(function (select) { return !select.value; })) return null;

    return (
      product.variants.find(function (variant) {
        if (!variant.available) return false;
        return selects.every(function (select) {
          return variant['option' + select.dataset.optionPosition] === select.value;
        });
      }) || null
    );
  }

  function setExtraOptionsVisibility(optionsEl, show) {
    if (!optionsEl) return;
    optionsEl.hidden = !show;
    optionsEl.classList.toggle('is-hidden', !show);
  }

  function renderExtraOptions(rowEl, product) {
    const optionsEl = rowEl.querySelector('[data-extra-options]');
    optionsEl.innerHTML = '';
    setExtraOptionsVisibility(optionsEl, false);

    const availableVariants = getAvailableExtraVariants(product);

    if (!productRequiresOptionUi(product)) {
      const variant = availableVariants[0] || null;
      if (variant) {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.setAttribute('data-extra-auto-variant', '');
        hidden.value = String(variant.id);
        optionsEl.appendChild(hidden);
      }
      return;
    }

    setExtraOptionsVisibility(optionsEl, true);

    product.options.forEach(function (option) {
      const label = document.createElement('label');
      label.className = 'river-run__extra-option-label';
      label.textContent = option.name;

      const select = document.createElement('select');
      select.setAttribute('data-extra-option-select', '');
      select.dataset.optionPosition = String(option.position);

      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select ' + option.name;
      select.appendChild(placeholder);

      option.values.forEach(function (value) {
        const opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;
        select.appendChild(opt);
      });

      label.appendChild(select);
      optionsEl.appendChild(label);
    });

    Array.from(optionsEl.querySelectorAll('select')).forEach(function (select) {
      select.addEventListener('change', function () {
        updateExtraRowVariant(rowEl);
      });
    });

    selectDefaultExtraOptions(rowEl);
  }

  function selectDefaultExtraOptions(rowEl) {
    const selects = Array.from(rowEl.querySelectorAll('[data-extra-option-select]'));
    if (!selects.length) return;

    const sortedSelects = selects.slice().sort(function (a, b) {
      return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition);
    });

    sortedSelects.forEach(function (select) {
      const firstOption = getFirstEnabledSelectOption(select);
      if (firstOption) select.value = firstOption.value;
    });
  }

  function updateExtraRowVariant(rowEl) {
    const handle = rowEl.querySelector('[data-extra-product-select]').value;
    const product = findExtraProduct(handle);
    const thumb = rowEl.querySelector('[data-extra-thumb]');
    const priceEl = rowEl.querySelector('[data-extra-price]');

    if (!product) {
      rowEl.dataset.extraVariantId = '';
      return;
    }

    const variant = resolveExtraVariant(product, rowEl);

    if (variant) {
      rowEl.dataset.extraVariantId = String(variant.id);
      if (thumb && variant.image) thumb.src = variant.image;
      if (priceEl && variant.priceFormatted) priceEl.textContent = variant.priceFormatted;
    } else {
      rowEl.dataset.extraVariantId = '';
    }
  }

  function onExtraProductChange(rowEl) {
    const handle = rowEl.querySelector('[data-extra-product-select]').value;
    const product = findExtraProduct(handle);
    const thumb = rowEl.querySelector('[data-extra-thumb]');
    const priceEl = rowEl.querySelector('[data-extra-price]');
    const optionsEl = rowEl.querySelector('[data-extra-options]');

    rowEl.dataset.extraVariantId = '';

    if (!product) {
      optionsEl.innerHTML = '';
      setExtraOptionsVisibility(optionsEl, false);
      if (thumb) {
        thumb.removeAttribute('src');
        thumb.style.display = 'none';
      }
      if (priceEl) priceEl.textContent = '';
      return;
    }

    if (thumb && product.image) {
      thumb.src = product.image;
      thumb.alt = product.title;
      thumb.style.display = '';
    } else if (thumb) {
      thumb.style.display = 'none';
    }
    if (priceEl) priceEl.textContent = product.priceFormatted || '';

    renderExtraOptions(rowEl, product);
    updateExtraRowVariant(rowEl);
  }

  function createExtraRow() {
    const row = document.createElement('div');
    row.className = 'river-run__extra-row';
    row.setAttribute('data-extra-row', '');

    const head = document.createElement('div');
    head.className = 'river-run__extra-row-head';

    const thumb = document.createElement('img');
    thumb.className = 'river-run__extra-thumb';
    thumb.setAttribute('data-extra-thumb', '');
    thumb.alt = '';
    thumb.width = 56;
    thumb.height = 56;
    thumb.loading = 'lazy';
    thumb.style.display = 'none';
    head.appendChild(thumb);

    const productLabel = document.createElement('label');
    productLabel.className = 'river-run__extra-option-label';
    productLabel.textContent = 'Product';

    const productSelect = document.createElement('select');
    productSelect.setAttribute('data-extra-product-select', '');

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select a product';
    productSelect.appendChild(placeholder);

    extraProductsData.forEach(function (product) {
      const opt = document.createElement('option');
      opt.value = product.handle;
      opt.textContent = product.priceFormatted
        ? product.title + ' — ' + product.priceFormatted
        : product.title;
      productSelect.appendChild(opt);
    });

    productLabel.appendChild(productSelect);
    head.appendChild(productLabel);

    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'river-run__extra-remove';
    removeBtn.setAttribute('aria-label', 'Remove this product');
    removeBtn.textContent = '\u00D7';
    head.appendChild(removeBtn);

    row.appendChild(head);

    const price = document.createElement('span');
    price.className = 'river-run__extra-price';
    price.setAttribute('data-extra-price', '');
    row.appendChild(price);

    const options = document.createElement('div');
    options.className = 'river-run__extra-options';
    options.setAttribute('data-extra-options', '');
    row.appendChild(options);

    productSelect.addEventListener('change', function () {
      onExtraProductChange(row);
    });
    removeBtn.addEventListener('click', function () {
      row.remove();
    });

    return row;
  }

  function getSelectedExtraProducts() {
    if (!extraRowsEl) return [];

    const items = [];
    Array.from(extraRowsEl.querySelectorAll('[data-extra-row]')).forEach(function (row) {
      const id = row.dataset.extraVariantId;
      if (id) {
        items.push({ id: Number(id), quantity: 1 });
      }
    });
    return items;
  }

  if (addExtraBtn && extraRowsEl) {
    addExtraBtn.addEventListener('click', function () {
      const row = createExtraRow();
      extraRowsEl.appendChild(row);
      const select = row.querySelector('[data-extra-product-select]');
      if (select) select.focus();
    });
  }

  function parseCartError(response, data) {
    if (!response.ok) throw data;
    return data;
  }

  function addRegistrationWithSignature(variantId, properties, signatureBlob) {
    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');

    Object.keys(properties).forEach(function (key) {
      formData.append('properties[' + key + ']', properties[key]);
    });

    formData.append(
      'properties[Waiver - Signature]',
      signatureBlob,
      'waiver-signature.png'
    );

    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    }).then(function (response) {
      return response.json().then(function (data) {
        return parseCartError(response, data);
      });
    });
  }

  function addAddonItems(addons) {
    if (!addons.length) {
      return Promise.resolve();
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: addons })
    }).then(function (response) {
      return response.json().then(function (data) {
        return parseCartError(response, data);
      });
    });
  }

  function resetSubmitButton(submitBtn) {
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Add Registration to Cart';
    }
  }

  bindGearGroups();
  bindAddonSelectEvents();
  syncIncludedGearToAddons();

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      setMessage('', '');

      if (!form.checkValidity()) {
        form.reportValidity();
        setMessage('Please complete all required fields.', 'error');
        return;
      }

      const waiverAgree = document.getElementById('waiver-agree');

      if (!waiverAgree || !waiverAgree.checked) {
        setMessage('You must accept the waiver to register.', 'error');
        return;
      }

      if (signaturePad.isEmpty()) {
        setMessage('Please draw your signature in the box before submitting.', 'error');
        if (signaturePadEl) {
          signaturePadEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      const shirtTankData = getGearGroupData(shirtTankGroup);
      const hatFlagData = getGearGroupData(hatFlagGroup);

      if (!shirtTankData.variantId) {
        setMessage('Please select your included shirt or tank and choose a size or option.', 'error');
        if (shirtTankGroup) {
          shirtTankGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      if (!hatFlagData.variantId) {
        setMessage('Please select your included hat or flag and choose an option.', 'error');
        if (hatFlagGroup) {
          hatFlagGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      const variantId = Number(form.querySelector('[name="id"]').value);
      const properties = formToProperties(form);
      const extraCartItems = collectCartLineItems();
      const submitBtn = form.querySelector('[type="submit"]');

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding to cart...';
      }

      signaturePad.toBlob(function (signatureBlob) {
        if (!signatureBlob) {
          setMessage('Unable to save signature. Please try again.', 'error');
          resetSubmitButton(submitBtn);
          return;
        }

        addRegistrationWithSignature(variantId, properties, signatureBlob)
          .then(function () {
            return addAddonItems(extraCartItems);
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function (error) {
            const description =
              (error && error.description) ||
              'Unable to add items to cart. Please try again.';
            setMessage(description, 'error');
            resetSubmitButton(submitBtn);
          });
      });
    });
  }
})();
